module.exports = __webpack_public_path__ + "static/img/ID.f5f86698.svg";